import * as React from 'react';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { AddItemModalContent } from './AddItemModalContent';
import { NobleModal } from '../../../../components';
import { SharedItems, SharedItemsVariables } from './__generated__/SharedItems';
import { BasicItem } from '../types';

interface AddItemModalProps {
  venueId: string;
  menuId: string;
  menuCategoryId: string;
  allowAddingNew: boolean;
  onCancel();
  onSave(item: BasicItem | null);
}
const SHARED_ITEMS_QUERY = gql`
  query SharedItems($venueId: ID!, $menuId: ID!, $menuCategoryId: ID!) {
    sharedItems(venueId: $venueId, menuId: $menuId, categoryId: $menuCategoryId) {
      id
      name
    }
  }
`;

export const AddItemModal: React.FC<AddItemModalProps> = (props) => {
  const { menuId, venueId, menuCategoryId, onCancel, onSave, allowAddingNew } = props;
  const { loading, data } = useQuery<SharedItems, SharedItemsVariables>(SHARED_ITEMS_QUERY, {
    variables: {
      venueId,
      menuId,
      menuCategoryId,
    },
  });

  return (
    <NobleModal isOpen={true} toggle={onCancel}>
      <NobleModal.Title title='Add an item' />
      <NobleModal.Body>
        {loading && <p>Loading...</p>}
        {data && (
          <AddItemModalContent
            items={data.sharedItems}
            allowAddingNew={allowAddingNew}
            onSave={onSave}
            onCancel={onCancel}
          />
        )}
      </NobleModal.Body>
    </NobleModal>
  );
};
